export default "__VITE_PUBLIC_ASSET__bae1d50d__"